import 'es6-promise/auto'
import Vue from 'vue'
import Buefy from 'buefy'
import VueClipboard from 'vue-clipboard2'
import {initializeApp} from 'firebase/app'
import router from '@/router'
import i18n from '@/i18n'
import store from '@/store'
import cognito from './cognito'
import firebaseSdkConfig from '@/config/firebase-app-sdk-config'
import '@/meta'

import 'scss/style.scss'

//import '@/sanitize'
import mixin from '@/mixins/site'
import * as filters from '@/filters'
import {SiteConfig} from '@/api/'
import App from '@/App'

const initApp = () => {
  Vue.use(Buefy)
  Vue.use(VueClipboard)
  Vue.mixin(mixin)
  Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key])
  })

  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    cognito,
    render: (h) => h(App),
  })
}

initializeApp(firebaseSdkConfig)
//firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)

initApp()
